import { useEffect } from 'react';

import { useAppSelector } from '../useAppSelector';
import { useAppDispatch } from '../useAppDispatch';

import {
  setCurrentPage,
  getAutocompleteList,
  clearAutocompleteList,
} from '../../store/slice/health-monitor/device-list';
import store from '../../store/store';

import { FIRST_PAGE, TIMEOUT_AUTOCOMPLETE_SEARCH } from '../../constant/constants';

export const useAutocompleteSearch = (shouldAutocompleteSearch: boolean) => {
  const searchInput = useAppSelector((state) => state.deviceList.searchInput);
  const columnToSearchBy = useAppSelector((state) => state.deviceList.columnToSearchBy);
  const dispatch = useAppDispatch();

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    timeout = setTimeout(() => {
      if (!shouldAutocompleteSearch) return;

      if (searchInput !== null) {
        dispatch(setCurrentPage(FIRST_PAGE));
        if (searchInput.length >= 3 && searchInput.length <= 15 && !store.getState().deviceList.isLoadingDeviceList) {
          dispatch(
            getAutocompleteList({
              search: searchInput,
              column: columnToSearchBy,
              maxSize: 15,
            }),
          );
        } else {
          dispatch(clearAutocompleteList());
        }
      }
    }, TIMEOUT_AUTOCOMPLETE_SEARCH);

    return () => clearTimeout(timeout);
  }, [dispatch, searchInput, columnToSearchBy, shouldAutocompleteSearch]);
};
